import axios from 'axios';
import { browserHistory } from 'react-router';
import { get, pickBy } from 'lodash';
import { normalize } from 'normalizr';

import signOut from '../actions/signOut';
import configService from '../services/configService';
import storage from '../services/storageService';
import recentlyUsedRequest from './recentlyUsed';

import StoreInstance from './StoreInstance';

// Create a new instance of axios
// https://github.com/axios/axios#creating-an-instance
const axiosClient = axios.create({
  baseURL: configService.getApiBasePath(),
});

// Request interceptors
axiosClient.interceptors.request.use((config) => ({
  ...config,
  headers: pickBy({
    'x-access-token': (window as any).token || storage.getToken(),
    ...config.headers,
  }),
}));

// Response interceptors
axiosClient.interceptors.response.use(
  // TODO: remove extended props from axios config
  // @ts-ignore
  ({ data, config: { schema, config }, ...other }) => {
    // TEMP: solution for recently used to be invoked only in next
    const regexp = RegExp('localhost:3000|next', '');
    if (window && regexp.test(window.location.href)) recentlyUsedRequest();
    return {
      ...other,
      data,
      config,
      // Normalizes the result JSON according to schema.
      // This makes every API response have the same shape, regardless of how nested it was.
      normalized: schema ? normalize(data, schema) : undefined,
    };
  },
  (error) =>
    Promise.reject(error).finally(() => {
      if (get(error, 'response.config.ignoreError')) {
        return;
      }
      const statusError = error?.response?.status ?? 0;

      const is401Error = statusError === 401;
      const is403Error = statusError === 403;
      const is500sError = statusError >= 500 && statusError < 600;

      const isErrorToRedirectOnEmbed = is500sError || is401Error || is403Error;
      const isOnEmbedPage = /\/embed\//.test(window.location.href);
      const ignoreError = !/\/insurances\//.test(window.location.href);

      // Redirect on 400s or 500s errors
      if (isErrorToRedirectOnEmbed && isOnEmbedPage) {
        browserHistory.push('/embed-error');
      } else if (is401Error && StoreInstance.store && ignoreError) {
        StoreInstance.store.dispatch(signOut({}));
      }
    }),
);

export default axiosClient;
